import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { Alerts } from '../../Icons/LeftRail/Alerts';
import { LOGIN_LAYOUT } from '../../Login/LoginLayoutComponent/Layouts/LogInLayout/constants';

import CommonBox, { LeftRailButton } from '../CommonBox/CommonBox';

import './JobNotificationsBox.scss';

const loggedOutDescription = 'Get notified when new jobs are posted.';
const jobsClickMetric = {
    misc_event_count: 1,
    misc_event_type: 'left-rail-jobs-click',
};
const savedJobsClickMetric = {
    misc_event_count: 1,
    misc_event_type: 'left-rail-saved-jobs-click',
};
const userCardjobsClickMetric = {
    misc_event_count: 1,
    misc_event_type: 'usercard-left-rail-job-alerts-click',
};
const userCardsavedJobsClickMetric = {
    misc_event_count: 1,
    misc_event_type: 'usercard-left-rail-saved-jobs-click',
};

const handleSavedJobsClick = () => {
    window.location = '/jobs/saved';
};

class JobNotificationsBox extends React.PureComponent {
    renderDescription = (isLoggedIn) => {
        const { notificationCount } = this.props;
        return isLoggedIn && notificationCount ? null : loggedOutDescription;
    };

    renderLoggedInContent = () => {
        const {
            openModal,
            notificationCount,
            savedJobsCount,
            profileCardView,
        } = this.props;

        if (profileCardView) {
            const jobAlertText =
                notificationCount === 1 ? 'Job Alert' : 'Job Alerts';
            const primaryButtonText =
                notificationCount > 0
                    ? `${notificationCount} ${jobAlertText}`
                    : 'Set Job Alerts';
            const secondaryButtonTextProfileCard =
                savedJobsCount === 1
                    ? `${savedJobsCount} SAVED JOB`
                    : `${savedJobsCount} SAVED JOBS`;

            return (
                <React.Fragment>
                    <LeftRailButton
                        text={primaryButtonText}
                        onClick={openModal}
                        metric={userCardjobsClickMetric}
                        className="border"
                    />
                    <LeftRailButton
                        text={secondaryButtonTextProfileCard}
                        onClick={handleSavedJobsClick}
                        metric={userCardsavedJobsClickMetric}
                        className="secondary-btn profileCardBtn hover-underline hover-text-grey"
                    />
                </React.Fragment>
            );
        }

        const notifications = this.props.notifications.slice(0, 5);
        const primaryButtonText = notificationCount ? 'Manage' : 'Explore';
        const secondaryButtonText =
            savedJobsCount === 1
                ? `${savedJobsCount} Saved Job`
                : `${savedJobsCount} Saved Jobs`;

        return (
            <React.Fragment>
                <div className="notifications">
                    {notifications.map((notification) => (
                        <a
                            key={notification.jobUrl}
                            className="notification"
                            href={notification.jobUrl}
                        >
                            <div className="title">
                                {'"'}
                                {notification.jobTitle}
                                {'"'}
                            </div>
                            <div className="location">
                                {notification.jobLocation}
                            </div>
                        </a>
                    ))}
                </div>
                <LeftRailButton
                    text={primaryButtonText}
                    onClick={openModal}
                    metric={jobsClickMetric}
                />
                <LeftRailButton
                    text={secondaryButtonText}
                    onClick={handleSavedJobsClick}
                    metric={savedJobsClickMetric}
                    className="secondary-btn"
                />
            </React.Fragment>
        );
    };

    renderLoggedOutContent = (pageContext) => {
        return (
            <div className="commonbox-btn-group">
                {pageContext.wrapAuth(
                    'leftrail-notifications',
                    LeftRailButton({ text: 'Explore' }),
                    { login_trigger: 'leftrail-jobs' },
                    null,
                    LOGIN_LAYOUT
                )}
                {pageContext.wrapAuth(
                    'leftrail-notifications',
                    LeftRailButton({
                        text: '0 Saved Jobs',
                        className: 'secondary-btn',
                    }),
                    { login_trigger: 'leftrail-jobs' },
                    null,
                    LOGIN_LAYOUT
                )}
            </div>
        );
    };

    render() {
        const count = this.props.notificationCount
            ? `(${this.props.notificationCount})`
            : '';
        const { profileCardView } = this.props;

        return (
            <PageConsumer>
                {(pageContext) => {
                    const title = pageContext.isLoggedIn()
                        ? `YOUR JOB ALERTS ${count}`
                        : `YOUR JOB ALERTS`;
                    return (
                        <CommonBox
                            svg={!profileCardView ? Alerts : null}
                            title={!profileCardView ? title : ''}
                            description={
                                !profileCardView
                                    ? this.renderDescription(
                                          pageContext.isLoggedIn()
                                      )
                                    : ''
                            }
                            className={profileCardView ? 'noPadding' : ''}
                        >
                            {pageContext.isLoggedIn()
                                ? this.renderLoggedInContent()
                                : this.renderLoggedOutContent(pageContext)}
                        </CommonBox>
                    );
                }}
            </PageConsumer>
        );
    }
}

JobNotificationsBox.propTypes = {
    /**
     * notifications(=job alerts) that a user follows
     */
    notifications: PropTypes.arrayOf(
        PropTypes.shape({
            jobNotificationId: PropTypes.number,
            jobTitle: PropTypes.string,
            jobLocation: PropTypes.string,
            jobSearchTerm: PropTypes.string,
            jobUrl: PropTypes.string,
            jobLat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            jobLng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ),
    /**
     * a total notification count
     */
    notificationCount: PropTypes.number,
    /**
     *  a function to open a notifications-modal
     */
    openModal: PropTypes.func,
    savedJobsCount: PropTypes.number,
    /**
     *  shows Job Alerts and Saved Jobs buttons only
     */
    profileCardView: PropTypes.bool,
};

JobNotificationsBox.defaultProps = {
    notifications: [],
    notificationCount: 0,
    savedJobsCount: 0,
    openModal: () => {},
    profileCardView: false,
};

export default JobNotificationsBox;
